import { createStore, combineReducers } from "redux";
import { applyMiddleware } from "redux";
import thunk from "redux-thunk";

import LayoutReducer from "../reducers/LayoutReducer";
import CommonReducer from "../reducers/CommonReducer";
import LoginReducer from "../reducers/LoginReducer";
import UserReducer from "../reducers/UserReducer";
import CompanyReducer from "../reducers/CompanyReducer";
import RoleReducer from "../reducers/RoleReducer";
import KanbanReducer from "../reducers/KanbanReducer";
import DashbaordReducer from "../reducers/DashboardReducer";
import TicketReducer from "../reducers/TicketReducer";
import TicketCalendarReducer from "../reducers/TicketCalendarReducer";
import DocumentReducer from "../reducers/DocumentReducer";
import CommentReducer from "../reducers/CommentReducer";
import ActionReducer from "../reducers/ActionReducer";
import NotificationReducer from "../reducers/NotificationReducer";
import EmailReducer from "../reducers/EmailReducer";
import PaymentReducer from "../reducers/PaymentReducer";
import LookupReducer from "../reducers/LookupReducer";
import CustomerReducer from "../reducers/CustomerReducer";
import VendorReducer from "../reducers/VendorReducer";
import GroupReducer from "../reducers/GroupReducer";
import ProductReducer from "../reducers/ProductReducer";
import LabReportReducer from "../reducers/LabReportReducer";
import AuditReducer from "../reducers/AuditReducer";
import IsoDashboardReducer from "../reducers/IsoDashboardReducer";
import IsoRequestReducer from "../reducers/IsoRequestReducer";
import AuditorReducer from "../reducers/AuditorReducer";
import TechnicalReviewerReducer from "../reducers/TechnicalReviewerReducer";
import InspectorReducer from "../reducers/InspectorReducer";
import IneDashboardReducer from "../reducers/IneDashboardReducer";
import IneRequestReducer from "../reducers/IneRequestReducer";
import IneCalendarReducer from "../reducers/IneCalendarReducer";
import IneTestingScopeReducer from "../reducers/IneTestingScopeReducer";
import IneTestingInspectorReducer from "../reducers/IneTestingInspectorReducer";
import IneTestingEquipmentReducer from "../reducers/IneTestingEquipmentReducer";
import ClientDocumentRequestReducer from "../reducers/ClientDocumentRequestReducer";
import IdiDashboardReducer from "../reducers/IdiDashboardReducer";
import IdiInspectionDashboardReducer from "../reducers/IdiInspectionDashboardReducer";
import IdiProjectReducer from "../reducers/IdiProjectReducer";
import IdiInspectionReducer from "../reducers/IdiInspectionReducer";
import IdiCustomerReducer from "../reducers/IdiCustomerReducer";
import IdiInspectorDetailReducer from "../reducers/IdiInspectorDetailReducer";
import IdiCalendarReducer from "../reducers/IdiCalendarReducer";
import IdiImportReducer from "../reducers/IdiImportReducer";


const rootReducer = combineReducers(
    { 
        Layout: LayoutReducer,
        common: CommonReducer,
        login: LoginReducer,
        user: UserReducer,
        company: CompanyReducer,
        role: RoleReducer,
        kanban: KanbanReducer,
        dashboard: DashbaordReducer,
        ticket: TicketReducer,
        ticketCalendar: TicketCalendarReducer,
        document: DocumentReducer,
        comment: CommentReducer,
        action: ActionReducer,
        notification: NotificationReducer,
        email: EmailReducer,
        payment: PaymentReducer,
        lookup: LookupReducer,
        customer: CustomerReducer,
        vendor: VendorReducer,
        group: GroupReducer, 
        product: ProductReducer,
        labReport: LabReportReducer,
        audit: AuditReducer,
        isodashboard: IsoDashboardReducer,
        iso: IsoRequestReducer,
        auditor: AuditorReducer,
        technicalReviewer: TechnicalReviewerReducer,
        inspector: InspectorReducer,
		inedashboard: IneDashboardReducer,
		ine: IneRequestReducer,
        calendar: IneCalendarReducer,
        scope: IneTestingScopeReducer,
        testingInspector: IneTestingInspectorReducer,
        equipment: IneTestingEquipmentReducer,
        cdr: ClientDocumentRequestReducer,
        ididashboard: IdiDashboardReducer,
        idiinspectiondashboard: IdiInspectionDashboardReducer,
        idi: IdiProjectReducer,
        idiinspection: IdiInspectionReducer,
        idicustomer: IdiCustomerReducer,
        idiinspector: IdiInspectorDetailReducer,
        idicalendar: IdiCalendarReducer,
        idiimport: IdiImportReducer
    }
);

var store = createStore(rootReducer, applyMiddleware(thunk));

const configureStore = () => {
    return store;
}

try {
    const user_info = JSON.parse(localStorage.getItem('ticketing_user_info'));
    const user_data = JSON.parse(localStorage.getItem('ticketing_user_data'));
    const user_token = localStorage.getItem('ticketing_user_token');
        
    if(user_info && user_token) {
        store.dispatch({ type: "LOGIN_LOADED", payload: user_info });
        store.dispatch({ type: "LOGIN_TOKEN_LOADED", payload: user_token });
    }

    if(user_data) {
        store.dispatch({ type: "LOGIN_DATA_LOADED", payload: user_data });
    }
}
catch (error) {
    console.log(error);
}

export default configureStore;